/**
 * V2 Place — data access. Split out of place.js on 2026-07-25 (488 lines
 * against the plan's ~400 budget), unchanged. Both reads were module-private
 * and stay that way; place.js imports them back.
 */
import * as gateway from '../../core/gateway.js';
import { cached } from '../../core/query.js';

const LOGS_SELECT =
  '*,public_profiles(id,username,full_name,avatar_url),' +
  'categories:category_id(id,name,emoji)';
const MAX_LOGS = 1000; // V1 location-panel.js:38 — stats need the whole book

export async function fetchLocation(id) {
  return cached(`location:${id}`, async () => {
    const { data, error } = await gateway.rawQuery(gateway.TABLES.LOCATIONS, {
      select: '*',
      filters: { id: `eq.${id}` },
      limit: 1,
    });
    if (error) throw error;
    return data?.[0] || null;
  });
}

export async function fetchLogs(locationId) {
  return cached(`location-logs:${locationId}`, async () => {
    const { data, error } = await gateway.rawQuery(gateway.TABLES.YOINKS, {
      select: LOGS_SELECT,
      filters: { location_id: `eq.${locationId}` },
      order: 'created_at.desc,id.desc',
      limit: MAX_LOGS,
    });
    if (error) throw error;
    return data || [];
  });
}
